module.exports = __webpack_public_path__ + "static/media/table_background_high_small.08862bca.jpg";